import { useContext } from 'react';
import CategoryHeader from '../CategoryHeader';
import Button from '../../../shared/Button';
import Box from '../../../shared/layouts/Box';
import CompareContainer from '../CompareContainer';
import CompareMortgageSection from './CompareMortgageSection';
import { CompareContext } from '../ComparePage';
import {useTranslation} from "react-i18next";
import useIconLibrary from "../../../../hooks/useIconLibrary";

const CompareMortgagePage = () => {
  const {
    showOnlyDiff,
    hasDiff,
    ownMortgageData,
    setOwnMortgageData,
    otherMortgageData,
    mortgageFields,
    loanpartFields,
    handleCopyAllFields,
    hasPageCopiedFields,
  } = useContext(CompareContext);
  const { MortgageIcon } = useIconLibrary();

  const { t } = useTranslation();

  const mortgageHasDiff =
    ownMortgageData.length !== otherMortgageData.length ||
    ownMortgageData?.some((mortgage, mortgageIndex) => {
      const otherMortgage = otherMortgageData?.[mortgageIndex];

      return (
        hasDiff(mortgageFields, mortgage, otherMortgage) ||
        (mortgage?.loanparts || []).length !==
          (otherMortgage?.loanparts || []).length ||
        mortgage?.loanparts?.some((loanpart, loanpartIndex) =>
          hasDiff(
            loanpartFields,
            loanpart,
            otherMortgage?.coverages?.[loanpartIndex]
          )
        )
      );
    });

  return (
    <CompareContainer
      section="mortgage"
      title={t("Hypotheek")}
      icon={<MortgageIcon height="2rem" width="2rem" />}
    >
      {showOnlyDiff && !hasPageCopiedFields('mortgage') && !mortgageHasDiff ? (
        <Box fontScale="m" width="50%">
          {t('Geen afwijkende gegevens gevonden')}
        </Box>
      ) : (
        <>
          <CompareMortgageSection />
          <CategoryHeader>
            <div />

            <Button
              onClick={() => {
                handleCopyAllFields(
                  otherMortgageData,
                  ownMortgageData,
                  'mortgage',
                  setOwnMortgageData
                );
              }}
            >
              {t('Alle gegevens overnemen')}
            </Button>
          </CategoryHeader>
        </>
      )}
    </CompareContainer>
  );
};

export default CompareMortgagePage;
